$(document).ready(function () {

  $('.plus_quantity').click(function(){
    var quantity_element = $(this).parent('.card_quick_quantity').find('input');
    var current = parseInt(quantity_element.val());
    current = parseInt(current) + 1;
    quantity_element.val(current);
  });

  $('.minus_quantity').click(function(){
    var quantity_element = $(this).parent('.card_quick_quantity').find('input');
    var current = parseInt(quantity_element.val());
    if(current > 1){
       current = parseInt(current) - 1;
       quantity_element.val(current); 
    }
  });
  
});